const baseURL = '/quoteRequests';

function createQuote({ plan, category } = {}) {
    return axios.post(`${baseURL}`, { plan, category }).then(R.prop('data'));
}

export default {
    createQuote,
};
